import type { SubQuestion, TaskDetails } from './reviewTypes';
import type { TaskDetailsValue } from '../../../shared/ui/forms/TaskDetailsFields';

/**
 * Pure task helpers for the sub-question row editor. Extracted from
 * {@link SubQuestionRow} so the component stays under the size limit and these
 * (side-effect-free) transforms can be unit-tested directly.
 */

/** An empty task shell used when a sub-question gains a task. Module-level for
 *  reference stability across renders. */
export const EMPTY_TASK_DETAILS: TaskDetails = { taskName: '', taskDescription: '' };

/** Returns the sub-question without its `taskDetails` key (rather than setting
 *  it to `undefined`) so it stays clean under exactOptionalPropertyTypes. */
export function stripTask(sub: SubQuestion): SubQuestion {
  const entries = Object.entries(sub).filter(([key]) => key !== 'taskDetails');
  return Object.fromEntries(entries) as unknown as SubQuestion;
}

/** Normalize a {@link TaskDetailsValue} to the Helios {@link TaskDetails} shape,
 *  omitting the duration key when absent (exactOptionalPropertyTypes-clean). */
export function toTaskDetails(next: TaskDetailsValue): TaskDetails {
  if (next.taskDurationDays === undefined) {
    return { taskName: next.taskName, taskDescription: next.taskDescription };
  }
  return {
    taskName: next.taskName,
    taskDescription: next.taskDescription,
    taskDurationDays: next.taskDurationDays,
  };
}
